import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, ListItem, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip } from '@material-ui/core'
import { globalExportService, globalGetService, globalPostService } from '../../../globalServices'
import { avationPlcInstance, leshaBankInstance, mtInstance, titanInstance } from '../../../shared_elements/components'
import { checkApiStatus, downloadFileType } from '../../../utils_v2'
import { useSnackbar } from 'notistack'
import { STableLoader } from '../../../shared_elements/loaders'
import { NoRecordFound } from '../../../shared'
const SummaryList = ({ item, selectedIds, onSelectItem, basicInfo }) => {
    return (
        <TableRow className='custom-exp-bdy-row'>
            <TableCell>{item?.name || '---'}</TableCell >
            <TableCell style={{textAlign:'center'}}>{
                <Checkbox
                    color='primary'
                    size='small'
                    edge="start"
                    tabIndex={-1}
                    checked={item?.module_checked ? true : false}
                    disableRipple
                    onChange={(e) => onSelectItem(item, 'module_checked', e.target.checked)}
                    inputProps={{ 'aria-labelledby': item.id }}
                />}</TableCell >
            <TableCell style={{textAlign:'center'}}>{
                <Checkbox
                    disabled={item?.module_checked ? false : true}
                    color='primary'
                    size='small'
                    edge="start"
                    tabIndex={-1}
                    checked={item?.remarks_checked ? true : false}
                    disableRipple
                    onChange={(e) => onSelectItem(item, 'remarks_checked', e.target.checked)}
                    inputProps={{ 'aria-labelledby': item.id }}
                />}</TableCell >
        </TableRow>
    )
}

export default function CustomLeaseExpModal({ onClose, basicInfo }) {
    const [expSummaryList, setExpSummaryList] = useState([])
    const [selectedIds, setSelectedIds] = useState([])
    const [expQuery, setExpQuery] = useState({ modulesArr: [], remarksArr: [] })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar ();
    const [isLoading, setLoading]= useState(false)
    const [isListLoad, setSkeletonLoader]= useState(false)
    useEffect(() => {
        getSummaryList()
    }, [])
    const getSummaryList = () => {
        setSkeletonLoader(true)
        globalGetService(`contracts/export/user_modules/`)
        .then(response => {
            setSkeletonLoader(false)
                if(checkApiStatus(response)){   
                    let modulesArr = [] 
                    let remarksArr = [] 
                    let arr =response.data.data?.map(item=>
                        {if(item?.module_checked){
                            modulesArr =[...modulesArr, item?.key] 
                        }
                        if(item?.remarks_checked){
                            remarksArr =[...remarksArr, item?.key] 
                        }}
                    )
                    setExpQuery({modulesArr:modulesArr,remarksArr:remarksArr})
                    setExpSummaryList(response.data.data)
                }
            })
    }
    const exportCustomReport = (data) => {
         let url;
            if ((titanInstance || avationPlcInstance || mtInstance || leshaBankInstance)) {
              url = `/contracts/${basicInfo.slug}/lease_summary_export/`;
            } else {
              url = `/contracts/${basicInfo.slug}/export-contract-summary/`;
            }
            const modulesString = `${expQuery?.modulesArr?.map(item=> item).join(",")}`;
            const remarksString = expQuery?.remarksArr?.length ?`${expQuery?.remarksArr?.map(item=> item).join(",")}`:null;
            let querySrt ={modules:modulesString, remarks:remarksString?remarksString :null}
            if(!titanInstance){
                querySrt= {...querySrt, download:'pdf'}
            }
            setLoading(true)
            globalExportService(url,querySrt, (titanInstance || avationPlcInstance || mtInstance)?'marketing':null)
            .then(response => {
                setLoading(false)
                if((titanInstance)){
                enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              }else{
                enqueueSnackbar('Download successful', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              if(basicInfo.asset_type == 2){
                downloadFileType((response?.data || response), 'ESN'+(basicInfo.asset.asset_name ? basicInfo.asset.asset_name:''+'_'+basicInfo.lessee.name)+'_Lease', 'pdf')
              }else if(basicInfo.asset_type == 3){
                downloadFileType((response?.data || response), 'APU'+(basicInfo.asset.serial_number ? basicInfo.asset.serial_number:''+'_'+basicInfo.lessee.name)+'_Lease', 'pdf')
              }else if(basicInfo.asset_type == 4){
                downloadFileType((response?.data || response), 'LG'+(basicInfo.asset.serial_number ? basicInfo.asset.serial_number:''+'_'+basicInfo.lessee.name)+'_Lease', 'pdf')
              }else if(basicInfo.asset_type == 5){
                downloadFileType((response?.data || response), 'PROPELLER'+(basicInfo.asset.serial_number ? basicInfo.asset.serial_number:''+'_'+basicInfo.lessee.name)+'_Lease', 'pdf')
              }else if (basicInfo.asset_type == 6) {
                downloadFileType((response?.data || response), 'ESN' + (basicInfo.asset.asset_name + '_' + basicInfo.lessee.name) + '_Lease', 'pdf')
              }else if (basicInfo.asset_type == 7) {
                downloadFileType((response?.data || response), 'ESN' + (basicInfo.asset.asset_name + '_' + basicInfo.lessee.name) + '_Lease', 'pdf')
              }else if (basicInfo.asset_type == 8) {
                downloadFileType((response?.data || response), 'ESN' + (basicInfo.asset.asset_name + '_' + basicInfo.lessee.name) + '_Lease', 'pdf')
              }else if (basicInfo.asset_type == 9) {
                downloadFileType((response?.data || response), 'ESN' + (basicInfo.asset.asset_name + '_' + basicInfo.lessee.name) + '_Lease', 'pdf')
              }else if (basicInfo.asset_type == 1) {
                downloadFileType((response?.data || response), 'MSN' + basicInfo.lessee.name + '_Lease', 'pdf')
              }
            }
            setTimeout(() => {onClose()}, 300);
            });
          }
    const onSelectItem = (data, key, value) => {
        let modulesArr = expQuery?.modulesArr
        let remarksArr = expQuery?.remarksArr
        if (key == 'module_checked') {
            if(value == false){
                remarksArr= remarksArr.filter(item => item !== data?.key)
            }
            modulesArr = value == true ? [...expQuery?.modulesArr, data?.key] : modulesArr.filter(item => item !== data?.key)
        } if (key == 'remarks_checked') {
            remarksArr = value == true ? [...expQuery?.remarksArr, data?.key] : remarksArr.filter(item => item !== data?.key)
        }
        setExpQuery({ modulesArr: modulesArr, remarksArr: remarksArr })
        let expListUpdated = expSummaryList.map(item => item?.key !== data?.key ? item :
            {...item,
                [key]: value,
                remarks_checked: key == 'module_checked' ? value == false ? false : item?.remarks_checked : value
            })
        setExpSummaryList(expListUpdated)
    }
    
    return (
        <div>
            <Dialog style={{ zIndex: "300", marginTop:'40px'}} open='true' onClose={() => onClose(false)} maxWidth={'md'} className='mou-dialog'>
                <DialogTitle>Custom Lease Summary </DialogTitle>
                <DialogContent dividers style={{ width: "650px", }}>
                {isListLoad ? <STableLoader count={4} />:
                    <Table className='mui-table-format lease-management-modal'>
                        <TableHead >
                            <TableRow >
                                <TableCell>Sections</TableCell>
                                <TableCell>Include Section</TableCell>
                                <TableCell>Include Remarks</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {expSummaryList?.length ? expSummaryList?.map(item => (<SummaryList
                                item={item}
                                onSelectItem={onSelectItem}
                                selectedIds={selectedIds}
                            />)):null
                            }
                            {
                                !isListLoad && !expSummaryList?.length?
                                <NoRecordFound />:null
                            }
                        </TableBody>
                    </Table>}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant='outlined' size='small' onClick={() => onClose()}>Cancel</Button>
                    <Button disabled={isListLoad || isLoading || ((expQuery.remarksArr?.length || expQuery.modulesArr?.length)== 0)} color="primary" variant='contained' size='small' onClick={() => exportCustomReport()}>
                        {isLoading?  <CircularProgress size={20} />: 'Export'}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
